import { useMutation, UseMutationResult } from 'react-query'
import AWS, { AWSError } from 'aws-sdk'
import { PromiseResult } from 'aws-sdk/lib/request'
import { random } from 'lodash'

import { useIsOnline } from 'utils/hook'
import { OfflineRequestsService } from 'views/AdjustersHub/utils/offlineRequestsService'

function randomKey(length = 7): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz1234567890'
  const randChars = []
  for (let i = 0; i < length; i++) {
    randChars.push(chars[random(chars.length)])
  }

  return randChars.join('')
}

function getFileExtensionAndUniqName(
  fileName: string,
  newExtension?: string
): Record<string, string> {
  const fileSplitNameArr = fileName.split('.')
  const fileExtension = newExtension ?? fileSplitNameArr.pop()!
  const fileNameWithRandomKey = `${fileSplitNameArr.join('.')}_${randomKey()}`
  const fileUniqName = `${fileNameWithRandomKey}.${fileExtension}`

  return {
    fileUniqName,
    fileExtension,
  }
}

AWS.config.update({
  region: process.env.AWS_REGION,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: process.env.AWS_IDENTITY_POOL_ID!,
  }),
})

const S3Bucket = new AWS.S3({
  params: { Bucket: process.env.AWS_BUCKET_NAME },
  region: process.env.AWS_REGION,
})

type PutObjRequest = AWS.S3.PutObjectRequest
type PutObjResponse = PromiseResult<AWS.S3.PutObjectOutput, AWSError>

const uploadFileToAWS = async (params: PutObjRequest): Promise<PutObjResponse> => {
  const response = await S3Bucket.putObject(params).promise()

  return response
}

const useUploadFileToAWS = (): UseMutationResult<PutObjResponse, AWSError, PutObjRequest> => {
  const isOnline = useIsOnline()

  return useMutation<PutObjResponse, AWSError, PutObjRequest>(uploadFileToAWS, {
    onError: async (error, params) => {
      if (!isOnline) {
        await OfflineRequestsService.saveRequest({
          method: 'useUploadFileToAWS',
          payload: params,
        })

        return
      }

      console.log('error useUploadFileToAWS', error)
    },
  })
}

export { getFileExtensionAndUniqName, S3Bucket, useUploadFileToAWS, PutObjRequest }
